import { Text, Heading, Button, BoxProps, Flex } from '@chakra-ui/react';
import NextLink from 'next/link';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import PlayIcon from '@/assets/icons/ic-play-white-outline.svg';

import { OriginalsSeries } from '@/resources/OriginalsSeries';

interface IOriginalsSliderItemProps extends BoxProps {
  originals: OriginalsSeries;
}

export const OriginalsSliderItem: FC<IOriginalsSliderItemProps> = ({ originals, ...rest }) => {
  const { t } = useTranslation();

  return (
    <Flex
      justifyContent="flex-start"
      alignItems="center"
      color="white"
      pl={{ base: '22px', md: '42px', lg: '108px' }}
      h={{ base: '342px', md: '430px', lg: '480px' }}
      backgroundImage={originals.largeHeaderImageUrl}
      backgroundPosition="center"
      backgroundSize="cover"
      backgroundRepeat="no-repeat"
      {...rest}
    >
      <Flex flexDir="column" alignItems="flex-start">
        <Text as="h2" textStyle="grotesk3XL" mb={{ base: 0, md: 4, lg: 6 }}>
          {originals.author.firstName}
          <br />
          {originals.author.lastName}
        </Text>
        <Heading
          as="h3"
          fontSize={{ base: 'lg', md: '2xl', lg: '1.75rem' }}
          lineHeight="3.875rem"
          mb={{ base: 0, md: 4, lg: 6 }}
        >
          {originals.title}
        </Heading>
        <NextLink href={`/originals/${originals.id}-${originals.slug}`} passHref legacyBehavior>
          <Button
            as="a"
            size="md"
            leftIcon={<PlayIcon width="24px" height="24px" />}
            _hover={{ textDecoration: 'none' }}
          >
            {t('library.originals.action.watch')}
          </Button>
        </NextLink>
      </Flex>
    </Flex>
  );
};
